import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Select, Modal as AntModal, Input, Form, Upload, Button, ConfigProvider, Checkbox, Tooltip, Tag, Flex, Spin } from 'antd';
import { FaLocationDot } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import styles from './SupportBlock.module.css';
import ReactWebcam from './ReactWebcam';
import { FaMoon, FaRegCopy } from "react-icons/fa";
import NewBookingBlock from '../NewBookingBlock';
import StepNavigator from '../StepNavigator/StepNavigator';

import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { LoadingOutlined } from '@ant-design/icons';






const SupportBlock = ({ bookingId, bookingEndTime, location, chargerTag, type, supportText, buttonText, cancelAction, showingReportIssue, issueSubmittedFeedback, isSessionCount, isCharging, timeFormatAmPm, connectorNumber, breatheConnectorId, connectorStatus, bookingNonRes, noOfConnectorsInCharger, isNightCharging, bookingStartTime, nightChargeEndTime }) => {
    // console.log("isCharging: ", isCharging)
    // console.log("isSessionCount: ", isSessionCount)
    // console.log("isSessionCount: ", isSessionCount)
    const [changeChargerModal, setChangeChargerModal] = useState(false);
    const [availableChargers, setAvailableChargers] = useState([]);
    const [availableChargersLoading, setAvailableChargersLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [newSelectedCharger, setNewSelectedCharger] = useState(null);

    const [bookingSupport, setBookingSupport] = useState([]);
    const [bookingSupportLoading, setBookingSupportLoading] = useState(false);

    const [issueListShowImage, setIssueListShowImage] = useState(false);
    const [nightChargeAvailableConnectorIDs, setNightChargeAvailableConnectorIDs] = useState([])


    // const [fileList, setFileList] = useState([]);
    const [issueForm, setIssueForm] = useState({ mainIssueType: null, issueType: null, description: null, capturedImage: null, plateNumber: null, pictureBox: false });

    const initialIssueForm = { mainIssueType: null, issueType: null, description: null, capturedImage: null, plateNumber: null, pictureBox: false };

    const [newBookingForm, setNewBookingForm] = useState({ selectedCharger: null, selectedFromDate: null, selectedToDate: null, refundRequest: false });


    const getAvailableChargers = async () => {
        try {
            setNewSelectedCharger(null);
            setAvailableChargersLoading(true);
            setAvailableChargers([]);
            const availableChargersList = await BreathAPIs.getAvailableChargers(bookingId, location?._id);
            setAvailableChargersLoading(false);

            if (availableChargersList && availableChargersList.data) {
                setAvailableChargers(availableChargersList.data.connectors);
                if(isNightCharging){
                    let connectorIDList = availableChargersList.data.connectors.map((conn)=> conn._id)
                    console.log("connector di list: ", connectorIDList)
                    console.log('booknig srart : ', bookingStartTime, bookingEndTime)
                    let response = await BreathAPIs.getAvailableNightChargeConnectors(bookingStartTime, nightChargeEndTime, connectorIDList)
                    console.log('respnose for night charge connectos: ', response.data)
                    setNightChargeAvailableConnectorIDs(response.data)
                }
               
            } else {
                console.error('No available chargers found');
            }
        } catch (error) {
            console.error('Error fetching available chargers:', error);
            setAvailableChargersLoading(false);
        }
    };

    const getBookingSupportList = async () => {

        try {
            setBookingSupportLoading(true);
            const bookingSupportList = await BreathAPIs.bookingSupportList(bookingId);
            console.log(bookingSupportList.data);
            if (bookingSupportList && bookingSupportList.data) {
                setBookingSupport(bookingSupportList.data);
            } else {
                console.error('No available chargers found');
            }
            setBookingSupportLoading(false);
        } catch (error) {
            setBookingSupportLoading(false);
            console.error('Error fetching available chargers:', error);
        }
    }

    const transformString = (input) => {
        if (!input) { return ''; }
        let transformed = input.replace(/-/g, ' ');
        if (transformed.length > 0) {
            transformed = transformed.charAt(0).toUpperCase() + transformed.slice(1);
        }
        return transformed;
    };



    useEffect(() => {
        if (changeChargerModal) {
            setIssueForm(initialIssueForm);
            setNewBookingForm({ selectedCharger: null, selectedFromDate: null, selectedToDate: null });
            getAvailableChargers();
        }
    }, [changeChargerModal]);

    useEffect(() => {
        if (issueForm.mainIssueType) {
            setIssueForm({ mainIssueType: issueForm.mainIssueType, issueType: null, description: null, capturedImage: null, plateNumber: null, pictureBox: false });
        }
    }, [issueForm.mainIssueType]);

    useEffect(() => {
        if (showingReportIssue) {
            getBookingSupportList();
        }
    }, [showingReportIssue]);

    const handleCopyClick = (textToCopy) => {

        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                toast.success('Text copied to clipboard');
                // You can also show a success message here if you want
            })
            .catch(err => {
                toast.error('Failed to copy text: ', err);
                // Handle any errors that might occur during copying
            });
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const currentDate = new Date();
        const dateToConvert = new Date(dateString);

        date.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        const options = {
            hour: 'numeric',
            minute: 'numeric',
            hour12: timeFormatAmPm
        };

        let updatedFormat = dateToConvert.toLocaleTimeString(undefined, options);

        if (date.getTime() > currentDate.getTime()) {
            updatedFormat = updatedFormat + (' (+1)');
        }

        return updatedFormat;
    }



    const handleIssueSubmit = async () => {
        try {

            if (!issueForm.mainIssueType) {
                toast.error('Please select an issue type.');
                return;
            }

            if (issueForm.mainIssueType !== 'parking-issue' && !issueForm.issueType) {
                toast.error('Please select an issue.');
                return;
            }
            if (issueForm.issueType === 'other' && !issueForm.description) {
                toast.error('Please describe your issue.');
                return;
            }

            if ((issueForm.mainIssueType === 'parking-issue' || issueForm.issueType === 'hardware-issue' || issueForm.pictureBox) && !issueForm.capturedImage) {
                toast.error('Please take an image');
                return;
            }

            if ((issueForm.mainIssueType === 'parking-issue' && issueForm.issueType !== 'other') && !issueForm.plateNumber) {
                toast.error('Please Enter Plate Number');
                return;
            }

            if ((issueForm.issueType !== 'other' && availableChargers.length && !newSelectedCharger) && (type !== 'charger-offline' && !isSessionCount)) {
                toast.error('Please select a charger');
                return;
            }




            if (((((issueForm.mainIssueType === 'charger-issue' && type === 'charger-offline') || (issueForm.mainIssueType === 'parking-issue'))) && issueForm.issueType !== 'other') && isSessionCount) {
                if (!newBookingForm?.selectedCharger && !newBookingForm?.refundRequest) {
                    toast.error('Please select a charger');
                    return;
                }
            }

            // console.log(issueForm);
            setSubmitting(true);
            const response = await BreathAPIs.createSupport(
                {
                    bookingId,
                    chargerStatus: type === 'charger-offline' ? 'offline' : 'online',
                    newSelectedCharger,
                    mainIssueType: issueForm.mainIssueType,
                    issueType: issueForm.issueType,
                    description: issueForm.description,
                    availableChargers: availableChargers.length,
                    capturedImage: issueForm.capturedImage,
                    plateNumber: issueForm.plateNumber,
                    newBookingForm: newBookingForm,
                    supportCreatedAt:new Date()
                }
            );
            toast.success(response.data.message);
            setSubmitting(false);
            setChangeChargerModal(false);
            issueSubmittedFeedback && issueSubmittedFeedback();

        } catch (error) {
            setSubmitting(false);
            if (error.response) {
                if (error.response.status === 409) {
                    toast.error('Charger already used.');
                } else {
                    toast.error('An error occurred.');
                }
            } else {
                toast.error('An unexpected error occurred.');
            }
        }
    };

    const handleIssueFormChange = (field, value) => {
        setIssueForm(prevForm => ({ ...prevForm, [field]: value }));
    };

    const handleModalClose = () => {
        setIssueForm(initialIssueForm);
        setTimeout(() => {
            setChangeChargerModal(false);
        }, "50");
    };

    let okText = '';
    let requestButtonEnable = false;



    if ((issueForm.issueType === 'other' || !issueForm.issueType) && issueForm.mainIssueType !== 'parking-issue') {
        okText = 'Submit Issue';
        requestButtonEnable = true;
    }
    else if (isSessionCount) {
        if (issueForm.mainIssueType && newBookingForm?.selectedCharger) {
            okText = 'Create new booking';
            requestButtonEnable = true;
        }
        else if (issueForm.mainIssueType && newBookingForm?.refundRequest) {
            okText = 'Request to refund';
            requestButtonEnable = true;
        }
        else {
            okText = 'Submit Issue';
            requestButtonEnable = true;
        }
    }
    else if (!availableChargersLoading && availableChargers.length === 0) {
        if (issueForm.mainIssueType) {
            okText = 'Request to refund';
            requestButtonEnable = true;
        }
        else {
            okText = 'Submit Issue';
            requestButtonEnable = true;
        }
    }
    else {
        if (newSelectedCharger !== null) {
            requestButtonEnable = true;
            okText = 'Request to change charger';
        }
        else {
            okText = 'Submit Issue';
        }
    }

    const getChargerNameById = (id, connectors) => {
        const connector = connectors.find(connector => connector._id === id);
        return connector ? connector.charger.chargerTag + ' - ' + connector.connectorNumber + ` (${connector.type}) ` : 'Unknown Charger';
    };

    const clearData = (index) => {
        console.log(index)
        switch (index) {
            case 1:
                setIssueForm({
                    mainIssueType: issueForm.mainIssueType,
                    issueType: null,
                    description: null,
                    capturedImage: null,
                    plateNumber: null,
                    pictureBox: false,
                    pictureBox: null
                });
                setNewSelectedCharger(null);
                setIssueListShowImage(false);
                setNewBookingForm(null);
                break;
            case 2:
                setIssueForm({
                    mainIssueType: issueForm.mainIssueType,
                    issueType: issueForm.issueType,
                    description: null,
                    capturedImage: null,
                    plateNumber: null,
                    pictureBox: false,
                    pictureBox: null
                });
                setNewSelectedCharger(null);
                setIssueListShowImage(false);
                setNewBookingForm(null);
                break;
            case 3:
                setIssueForm({
                    mainIssueType: issueForm.mainIssueType,
                    issueType: issueForm.issueType,
                    description: issueForm.description,
                    pictureBox: issueForm.pictureBox,
                    capturedImage: null,
                    plateNumber: null,
                });
                setNewSelectedCharger(null);
                setIssueListShowImage(false);
                setNewBookingForm(null);
                break;
            case 4:
                setIssueForm({
                    mainIssueType: issueForm.mainIssueType,
                    issueType: issueForm.issueType,
                    description: issueForm.description,
                    capturedImage: issueForm.capturedImage,
                    plateNumber: null,
                    pictureBox: issueForm.pictureBox
                });
                setNewSelectedCharger(null);
                setIssueListShowImage(false);
                setNewBookingForm(null);
                break;
            case 5:
                setIssueForm({
                    mainIssueType: issueForm.mainIssueType,
                    issueType: issueForm.issueType,
                    description: issueForm.description,
                    capturedImage: issueForm.capturedImage,
                    plateNumber: issueForm.plateNumber,
                    pictureBox: issueForm.pictureBox
                });
                setNewSelectedCharger(null);
                setIssueListShowImage(false);
                setNewBookingForm(null);
                break;
            case 6:
                setIssueForm({
                    mainIssueType: issueForm.mainIssueType,
                    issueType: issueForm.issueType,
                    description: issueForm.description,
                    capturedImage: issueForm.capturedImage,
                    plateNumber: issueForm.plateNumber,
                    pictureBox: issueForm.pictureBox
                });
                setNewBookingForm(null);
            case 7:
                setIssueForm({
                    mainIssueType: issueForm.mainIssueType,
                    issueType: issueForm.issueType,
                    description: issueForm.description,
                    capturedImage: issueForm.capturedImage,
                    plateNumber: issueForm.plateNumber,
                    pictureBox: issueForm.pictureBox
                });
                setIssueListShowImage(false);
                break;
        }
    }




    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: '#18365E',
                colorBgContainer: '#ffffff',
                boxShadow: 'none'
            },
        }}>
            <div className={styles['change-charger-container']}>
                <div className={styles['change-charger-panel']}>
                    {bookingSupport.length > 0
                        ?
                        <Tooltip color='#66768c' placement="top" title={`${bookingSupport.length} Ticket${bookingSupport.length === 1 ? '' : 's'} created!`} >
                            <div>{supportText || 'Charger offline'}</div>
                        </Tooltip>
                        :
                        <div>{supportText || 'Charger offline'}</div>
                    }
                    <button onClick={() => setChangeChargerModal(true)} className={`${styles['btn-change-charger']} ${cancelAction ? styles['with-close'] : ''}`}>
                        {buttonText || 'Support'}
                    </button>
                    {cancelAction && <button onClick={cancelAction} className={styles['btn-cancel']}>X</button>}
                </div>

                {/* {bookingSupportLoading && <>
                    <div className='clearfix' />
                    <div> <p className={`card-text placeholder-glow`}><span className="placeholder col-12 rounded"></span> </p> </div>
                </>}
                {bookingSupport.length > 0 && <>
                    <div className='clearfix'></div>
                    <div className={styles['support-list']}>
                        {bookingSupport?.map((option, key) => (
                            <div className={styles['support-item']} key={option._id}>
                                <Tooltip color='#66768c' placement="top" title={'Reported issue : No:' + (key + 1)} >
                                    <span>{transformString(option.mainIssueType)}</span>
                                </Tooltip>

                                <Tooltip color='#527e69' placement="top" title={'Copy track Code'} >
                                    <button onClick={() => handleCopyClick(option._id)} className={styles['btn-copy']}>
                                        <FaRegCopy />
                                    </button>
                                </Tooltip>
                            </div>
                        ))}
                    </div>
                </>} */}

            </div>
            <div className={styles['card-bottom-right']}>
                <div className={styles['main']}>{chargerTag} {noOfConnectorsInCharger !== 1 ? ` - #${connectorNumber}` : ""}</div>
                <div className={styles['sub']}><FaLocationDot />{location?.locationName}</div>
            </div>

            <AntModal
                title="Support"
                open={changeChargerModal}
                onCancel={handleModalClose}
                footer={null}
            >
                {!availableChargersLoading ?
                    <Form layout="vertical">

                        <StepNavigator
                            isSaving={submitting}
                            handleSave={handleIssueSubmit}
                            submitButtonLabel={okText}


                            components={[
                                {
                                    onPreviousClick: (index) => { clearData(1) },
                                    canGoNext: issueForm.mainIssueType ? true : false,
                                    component:
                                        <Form.Item label="Issue Type" required>
                                            <Select
                                                placeholder="Please select an issue"
                                                style={{ width: '100%' }}
                                                onChange={val => { handleIssueFormChange('mainIssueType', val); handleIssueFormChange('issueType', null) }}
                                                value={issueForm.mainIssueType}
                                                options={
                                                    [
                                                        { value: 'charger-issue', label: 'Charger Issue' },
                                                        ...(!isCharging ? [{ value: 'parking-issue', label: 'Parking Issue' }] : []),
                                                    ]
                                                }

                                            />
                                        </Form.Item>
                                },
                                {
                                    onPreviousClick: (index) => { clearData(2) },
                                    canGoNext: issueForm.issueType ? true : false,
                                    component: issueForm.mainIssueType == 'charger-issue' ?
                                        <Form.Item label="Issue" required>
                                            <Select
                                                placeholder="Please select an issue"
                                                style={{ width: '100%' }}
                                                onChange={val => handleIssueFormChange('issueType', val)}
                                                value={issueForm.issueType}
                                                options={
                                                    isCharging ?
                                                        [
                                                            { value: 'vehicle-not-accepting-charge', label: 'Vehicle not accepting charge' },
                                                            { value: 'other', label: 'Other' },
                                                        ]
                                                        :
                                                        [
                                                            { value: 'not-able-to-start-charge', label: 'Not able to start charge' },
                                                            { value: 'vehicle-not-accepting-charge', label: 'Vehicle not accepting charge (EV Suspended)' },
                                                            { value: 'hardware-issue', label: 'Hardware issue (e.g., broken connector, cable)' },
                                                            { value: 'other', label: 'Other' },
                                                        ]

                                                }
                                            />
                                        </Form.Item> : null
                                },
                                {
                                    onPreviousClick: (index) => { clearData(3) },
                                    canGoNext: issueForm.description ? true : false,
                                    component: issueForm.issueType === 'other' ?
                                        <>
                                            <Form.Item label="Please describe your issue" required>
                                                <Input.TextArea
                                                    placeholder="Please describe the issue"
                                                    onChange={e => handleIssueFormChange('description', e.target.value)}
                                                    value={issueForm.description}
                                                />
                                                <Checkbox className='mt-2' checked={issueForm.pictureBox} onChange={(e) => handleIssueFormChange('pictureBox', e.target.checked)}>Take an Image</Checkbox>
                                            </Form.Item>
                                        </> : null
                                },
                                {
                                    onPreviousClick: (index) => { clearData(4) },
                                    canGoNext: issueForm.capturedImage ? true : false,
                                    component: (issueForm.mainIssueType === 'parking-issue' || issueForm.issueType === 'hardware-issue' || issueForm.pictureBox) ?
                                        <Form.Item
                                            label="Take a picture"
                                            required
                                        >
                                            <ReactWebcam
                                                capturedImage={issueForm.capturedImage}
                                                setCapturedImage={val => handleIssueFormChange('capturedImage', val)}
                                            />
                                        </Form.Item> : null
                                },
                                {
                                    onPreviousClick: (index) => { clearData(5) },
                                    canGoNext: issueForm.plateNumber ? true : false,
                                    component: issueForm.mainIssueType === 'parking-issue' ?
                                        <Form.Item label="Plate Number" required>
                                            <Input
                                                placeholder="Please Enter Your Plate Number"
                                                onChange={e => handleIssueFormChange('plateNumber', e.target.value)}
                                                value={issueForm.plateNumber}
                                            />
                                        </Form.Item> : null
                                },
                                {
                                    onPreviousClick: (index) => { clearData(6) },
                                    canGoNext: ((!availableChargersLoading && availableChargers.length === 0) || newSelectedCharger) ? true : false,
                                    component: (((issueForm.mainIssueType === 'parking-issue') || (issueForm.issueType && issueForm.issueType !== 'other')) && availableChargers.length !== 0 && !isSessionCount) ?
                                        <>
                                            {/* {console.log("available connectors : ", availableChargers)}
                                            {console.log("nigh charge: ", nightChargeAvailableConnectorIDs)}
                                            {
                                                availableChargers.map(connector => {
                                                        console.log(typeof connector._id)
                                                        console.log(typeof nightChargeAvailableConnectorIDs[0])
                                                        console.log('connector in array: ', (connector._id.toString() in nightChargeAvailableConnectorIDs) ? "OverNight Charge" : "over ight false")
                                                })
                                            } */}
                                            {(availableChargers.length === 0 && !availableChargersLoading) ?
                                                <div className={styles['no-charger-message']}>No chargers available</div> :
                                                <>
                                                    <div className={styles['current-charger-block']}><span>Your Current Charger: <b>{chargerTag} {noOfConnectorsInCharger !== 1 ? ` - #${connectorNumber}` : ""}</b></span></div>
                                                    <Form.Item label={<span>Select a Charger for Reallocation</span>} required>
                                                        <Select
                                                            placeholder="Select a charger"
                                                            style={{ width: '100%' }}
                                                            onChange={val => setNewSelectedCharger(val)}
                                                            value={newSelectedCharger}
                                                            loading={availableChargersLoading}
                                                            options={availableChargers.map(connector => ({ 
                                                                value: connector._id, 
                                                                label: ((nightChargeAvailableConnectorIDs.includes(connector._id)) ? "🌙" : "") + connector.charger.chargerTag + (connector.noOfConnectorsInCharger !== 1 ? ` - #${connector.connectorNumber} ` : "") + ` (${connector.type}) `
                                                            }))} //(String(connector._id) in nightChargeAvailableConnectorIDs) ? "OverNight Charge" : ""
                                                        />
                                                    </Form.Item></>}
                                        </> : null

                                },
                                // console.log('newBookingForm', newBookingForm),
                                // console.log("issueForm", issueForm),
                                // console.log("isSessionCount", isSessionCount),
                                // console.log("isCharging", isCharging),
                                // console.log("type", type),
                                {// booking form
                                    onPreviousClick: (index) => { clearData(7) },
                                    canGoNext: (newBookingForm?.selectedCharger || newBookingForm?.refundRequest) ? true : false,
                                    component: (((((issueForm.mainIssueType === 'charger-issue' && type === 'charger-offline') || (issueForm.mainIssueType === 'parking-issue' || (issueForm.mainIssueType === 'charger-issue' && issueForm.issueType === 'hardware-issue' ) ))) && issueForm.issueType !== 'other') && isSessionCount) ?
                                        <>
                                            <NewBookingBlock
                                                bookingEndTime={bookingEndTime}
                                                newBookingForm={newBookingForm}
                                                setNewBookingForm={setNewBookingForm}
                                                location_id={location._id}
                                                timeFormatAmPm={timeFormatAmPm}
                                                bookingNonRes={bookingNonRes}
                                                bookingStartTime={bookingStartTime}
                                                isNightCharging={isNightCharging}
                                                nightChargeEndTime={nightChargeEndTime}
                                            />
                                        </> : null

                                },
                                {
                                    onPreviousClick: (index) => { clearData(8) },
                                    canGoNext: true,
                                    component: (issueForm.mainIssueType) ?
                                        <div className={styles['support-issues-list']}>

                                            {(((((issueForm.mainIssueType === 'charger-issue' && type === 'charger-offline') || (issueForm.mainIssueType === 'parking-issue' ||  (issueForm.mainIssueType === 'charger-issue' && issueForm.issueType === 'hardware-issue' ) ))) && issueForm.issueType !== 'other') && isSessionCount) ?
                                                <>

                                                    {issueForm.mainIssueType !== null && <div className={styles.item}>Issue Type <b>{transformString(issueForm.mainIssueType)}</b></div>}
                                                    {issueForm.issueType !== null && <div className={styles.item}>Issue <b>{transformString(issueForm.issueType)}</b></div>}
                                                    {/* {console.log("newBookingForm", newBookingForm)} */}
                                                    {newBookingForm?.selectedCharger ? <>
                                                        {!issueForm?.newBookingForm?.selectedCharger && <div className={styles.item}>Selected Charger <b>{newBookingForm?.selectedCharger?.charger?.chargerTag} {newBookingForm.selectedCharger?.noOfConnectorsInCharger !== 1 ? ` - #${newBookingForm.selectedCharger?.connectorNumber}` : ""} {` (${newBookingForm.selectedCharger?.type}) `}</b></div>}
                                                        {!issueForm?.newBookingForm?.selectedCharger && <div className={styles.item}>Selected Time <b>{`${formatDate(newBookingForm?.selectedFromDate)} - ${formatDate(newBookingForm?.selectedToDate)}`}</b></div>}

                                                    </> : <></>}

                                                </>
                                                :
                                                <>

                                                    {issueForm.mainIssueType !== null && <div className={styles.item}>Issue Type <b>{transformString(issueForm.mainIssueType)}</b></div>}
                                                    {issueForm.issueType !== null && <div className={styles.item}>Issue <b>{transformString(issueForm.issueType)}</b></div>}
                                                    {issueForm.description !== null && <div className={styles.item}>Description <b>{issueForm.description}</b></div>}
                                                    {issueForm.capturedImage !== null && <div className={styles.item}>Image <b className={styles['btn-show-image']} onClick={() => setIssueListShowImage(!issueListShowImage)}>
                                                        {issueListShowImage ? <>Hide <FaEyeSlash /></> : <>Show <FaEye /></>}
                                                    </b></div>}
                                                    {(issueListShowImage && issueForm.capturedImage !== null) && <div className={styles.item}><img src={issueForm.capturedImage} /></div>}
                                                    {issueForm.plateNumber !== null && <div className={styles.item}>Plate Number <b>{issueForm.plateNumber}</b></div>}
                                                    {newSelectedCharger !== null ? <div className={styles.item}>Selected Charger <b>{getChargerNameById(newSelectedCharger, availableChargers)}</b></div> :

                                                        <>
                                                            {(availableChargers.length === 0 && issueForm.issueType !== 'other' && issueForm.mainIssueType) &&
                                                                <div className={styles.item}>Selected Charger <b className='text-danger'>No Chargers available</b></div>

                                                            }
                                                        </>

                                                    }

                                                </>}



                                        </div>
                                        : null
                                },

                            ]}


                        />

                    </Form> :
                    <div className={styles['support-loader']}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                    </div>
                }


                {/* )} */}
            </AntModal>
        </ConfigProvider>
    );
};

SupportBlock.propTypes = {
    bookingId: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    chargerTag: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    supportText: PropTypes.string,
    buttonText: PropTypes.string,
    cancelAction: PropTypes.func,
};

export default SupportBlock;
